function Workspaces() {
    return ("workspaces");
}

export default Workspaces;